import { render, staticRenderFns } from "./showPirceInfo.vue?vue&type=template&id=22395a91&scoped=true"
import script from "./showPirceInfo.vue?vue&type=script&lang=js"
export * from "./showPirceInfo.vue?vue&type=script&lang=js"
import style0 from "./showPirceInfo.vue?vue&type=style&index=0&id=22395a91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22395a91",
  null
  
)

export default component.exports